import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 1000 } }
  static targets = ["status", "form"]

  connect() {
    this.timeout = null
  }

  save() {
    clearTimeout(this.timeout)
    this.updateStatus("Unsaved changes...")

    this.timeout = setTimeout(() => {
      this.updateStatus("Saving...")
      const form = this.hasFormTarget ? this.formTarget : this.element.closest("form") || this.element
      form.requestSubmit()

      // Listen for successful submission
      form.addEventListener("turbo:submit-end", (event) => {
        if (event.detail.success) {
          this.updateStatus("Saved")
        } else {
          this.updateStatus("Save failed")
        }
      }, { once: true })
    }, this.delayValue)
  }

  updateStatus(text) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = text
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
